import { useQuery } from '@tanstack/react-query';
import { plantApi } from '../api';
import { queryKeys } from '../queries/keys';
import type { PlantSummary } from '../types';

function requestErrorMessage(reason: unknown, fallback: string): string {
  const detail = (reason as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  const message = (reason as { message?: string })?.message;
  return message || fallback;
}

export interface PlantsQueryState {
  plants: PlantSummary[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<unknown>;
}

export function usePlants({ enabled = true }: { enabled?: boolean } = {}): PlantsQueryState {
  const query = useQuery({
    queryKey: queryKeys.plants(),
    queryFn: () => plantApi.listPlants(),
    enabled,
  });

  return {
    plants: query.data ?? [],
    loading: query.isLoading,
    error: query.error
      ? requestErrorMessage(query.error, 'Plants could not be loaded.')
      : null,
    refetch: query.refetch,
  };
}
